module.exports = __webpack_public_path__ + "/Users/zhangming/code-zm/finup-credit/static/dist/img/banner1.cd53b95.png";


//////////////////
// WEBPACK FOOTER
// ./static/about/images/banner1.png
// module id = 5
// module chunks = 0